module.exports = __webpack_public_path__ + "img/forbes-white.72e06077.svg";